"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("superdesk-core/scripts/index");
var extension_1 = __importDefault(require("superdesk-core/scripts/extensions/annotationsLibrary/dist/src/extension"));
var extension_2 = __importDefault(require("superdesk-core/scripts/extensions/markForUser/dist/src/extension"));
var extension_3 = __importDefault(require("superdesk-core/scripts/extensions/datetimeField/dist/src/extension"));
setTimeout(function () {
    index_1.startApp([extension_1.default, extension_2.default, extension_3.default], {});
});
exports.default = angular.module('main.superdesk', []);



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 2273
// module chunks = 0